var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 9.9-1M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgUnlock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDEwLjk5OTJWNi45OTkxOEM2Ljk5ODc1IDUuNzU5MjMgNy40NTgyOCA0LjU2MzA0IDguMjg5MzcgMy42NDI4NEM5LjEyMDQ3IDIuNzIyNjQgMTAuMjYzOCAyLjE0NDA4IDExLjQ5NzUgMi4wMTk0N0MxMi43MzEyIDEuODk0ODUgMTMuOTY3MSAyLjIzMzA4IDE0Ljk2NTUgMi45Njg0OUMxNS45NjM4IDMuNzAzOSAxNi42NTMzIDQuNzg0MDIgMTYuOSA1Ljk5OTE4TTUgMTAuOTk5MkgxOUMyMC4xMDQ2IDEwLjk5OTIgMjEgMTEuODk0NiAyMSAxMi45OTkyVjE5Ljk5OTJDMjEgMjEuMTAzNyAyMC4xMDQ2IDIxLjk5OTIgMTkgMjEuOTk5Mkg1QzMuODk1NDMgMjEuOTk5MiAzIDIxLjEwMzcgMyAxOS45OTkyVjEyLjk5OTJDMyAxMS44OTQ2IDMuODk1NDMgMTAuOTk5MiA1IDEwLjk5OTJaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";